import React from "react";
import styled from 'styled-components';
import { Button as BootstrapButton } from 'react-bootstrap'
import booksitoutIcon from '../../config/BooksitoutIcon';

interface Props {
    state: 'ADD' | 'DELETE'
    onAdd?: (...args: any[]) => void;
    onDelete?: (...args: any[]) => void;
}

const AddDeleteButton: React.FC<Props> = ({ state, onAdd, onDelete }) => {
    if (state === 'ADD') {
        return (
            // @ts-ignore
            <ButtonContainer onClick={onAdd} variant="book">
                <AddButton />
            </ButtonContainer>
        )
    } else {
        return (
            <ButtonContainer onClick={onDelete} variant="book-danger">
                <DeleteButton />
            </ButtonContainer>
        )
    }
}

const ButtonContainer = styled(BootstrapButton).attrs({
    className: 'clickable'
})`
    width: 30px;
    height: 30px;
    border-radius: 50px;
    padding: 0;
`;

const AddButton = styled(booksitoutIcon.add)`
    padding: 0;

    position: relative;
    bottom: 2px;
    left: 0.25px;
`;

const DeleteButton = styled(booksitoutIcon.delete)`
    padding: 0;

    position: relative;
    bottom: 2px;
    left: 0.25px;
`;

export default AddDeleteButton